export const ActionTypes = {
  ADD_SPORTS: '[APP DATA] ADD SPORTS',
  ADD_EVENTS: '[APP DATA] ADD EVENTS',
  ADD_BET_OFFERS: '[APP DATA] ADD BET OFFERS',
  ADD_PARTICIPANTS: '[APP DATA] ADD PARTICIPANTS',
  ADD_OUTCOMES: '[APP DATA] ADD OUTCOMES',
  LOAD_QUICKLINKS_SUCCESS: '[APP DATA] LOAD QUICKLINKS SUCCESS',
  LOAD_SPORTGROUPS_REQUEST: '[APP DATA] LOAD SPORTGROUPS REQUEST',
  LOAD_SPORTGROUPS_SUCCESS: '[APP DATA] LOAD SPORTGROUPS SUCCESS',
  LOAD_SPORTGROUPS_FAILURE: '[APP DATA] LOAD SPORTGROUPS FAILURE',
  LOAD_OPEN_BETS_REQUEST: '[APP DATA] LOAD OPEN BETS REQUEST',
  LOAD_OPEN_BETS_SUCCESS: '[APP DATA] LOAD OPEN BETS SUCCESS',
  LOAD_OPEN_BETS_FAILURE: '[APP DATA] LOAD OPEN BETS FAILURE',
  ADD_LIVE_EVENT: '[APP DATA] ADD LIVE EVENT',
  REMOVE_EVENT: '[APP DATA] REMOVE EVENT',
  UPDATE_EVENT_SCORE: '[APP DATA] UPDATE EVENT SCORE',
  UPDATE_EVENT_STATS: '[APP DATA] UPDATE EVENT STATS',
  UPDATE_MATCH_CLOCK: '[APP DATA] UPDATE MATCH CLOCK',
  REMOVE_MATCH_CLOCK: '[APP DATA] REMOVE MATCH CLOCK',
  ADD_BET_OFFER: '[APP DATA] ADD BET OFFER',
  REMOVE_BET_OFFER: '[APP DATA] REMOVE BET OFFER',
  ADD_BET_OFFER_ODDS: '[APP DATA] ADD BET OFFER ODDS',
  REMOVE_BET_OFFER_ODDS: '[APP DATA] REMOVE BET OFFER ODDS',
  UPDATE_BET_OFFER_ODDS: '[APP DATA] UPDATE BET OFFER ODDS',
  UPDATE_BET_OFFER_STATUS: '[APP DATA] UPDATE BET OFFER STATUS',
  SET_NEW_START_DATE: '[APP DATA] SET NEW START DATE'
};

export class Actions {
  /**
   * Add sports action.
   * @param {ISportsMap} payload - Sports map.
   * @return {IActionWithPayload<ISportsMap>} - Action.
   */
  static addSports(payload) {
    return {
      type: ActionTypes.ADD_SPORTS,
      payload
    };
  }

  /**
   * Add events action.
   * @param {IEventsMap} payload - Events map.
   * @return {IActionWithPayload<IEventsMap>} - Action.
   */
  static addEvents(payload) {
    return {
      type: ActionTypes.ADD_EVENTS,
      payload
    };
  }

  static addParticipants(participants) {
    return {
      type: ActionTypes.ADD_PARTICIPANTS,
      payload: participants
    };
  }

  /**
   * Add outcomes action.
   * @param {IOutcomesMap} payload - Outcomes map.
   * @return {IActionWithPayload<IOutcomesMap>} - Action.
   */
  static addOutcomes(payload) {
    return {
      type: ActionTypes.ADD_OUTCOMES,
      payload
    };
  }

  static loadQuickLinksSuccess(quicklinks) {
    return { type: ActionTypes.LOAD_QUICKLINKS_SUCCESS, quicklinks };
  }

  /**
   * Load sport groups request action.
   * @return {IAction} - Action.
   */
  static loadSportGroupsRequest() {
    return {
      type: ActionTypes.LOAD_SPORTGROUPS_REQUEST
    };
  }

  static loadSportGroupsSuccess(sportsData) {
    return {
      type: ActionTypes.LOAD_SPORTGROUPS_SUCCESS,
      payload: sportsData
    };
  }

  /**
   * Load sports groups failure action.
   * @return {IAction} - Action.
   */
  static loadSportGroupsFailure() {
    return {
      type: ActionTypes.LOAD_SPORTGROUPS_FAILURE
    };
  }

  /**
   * Load open bets request action.
   * @return {IAction} - Action.
   */
  /*static loadOpenBetsRequest() {
    return {
      type: ActionTypes.LOAD_OPEN_BETS_REQUEST
    }
  }*/

  /*static loadOpenBetsSuccess(openBets) {
    return {
      type: ActionTypes.LOAD_OPEN_BETS_SUCCESS,
      payload: openBets
    }
  }*/

  /**
   * Load open bets failure action.
   * @return {IAction} - Action.
   */

  /*static loadOpenBetsFailure() {
    return {
      type: ActionTypes.LOAD_OPEN_BETS_FAILURE
    }
  }*/


  /**
   * Add bet offers action.
   * @param {IBetOffersMap} payload - Bet offers map.
   * @return {IActionWithPayload<IBetOffersMap>} - Action.
   */
  static addBetOffers(payload) {
    return {
      type: ActionTypes.ADD_BET_OFFERS,
      payload
    };
  }

  static addLiveEvent(event) {
    return {
      type: ActionTypes.ADD_LIVE_EVENT,
      payload: event
    };
  }

  static removeEvent(eventId) {
    return {
      type: ActionTypes.REMOVE_EVENT,
      payload: eventId
    };
  }

  static updateEventScore(score) {
    return {
      type: ActionTypes.UPDATE_EVENT_SCORE,
      payload: score
    };
  }

  static updateEventStats(stats) {
    return {
      type: ActionTypes.UPDATE_EVENT_STATS,
      payload: stats
    };
  }

  static updateMatchClock(matchClock) {
    return {
      type: ActionTypes.UPDATE_MATCH_CLOCK,
      payload: matchClock
    };
  }

  static removeMatchClock(eventId) {
    return {
      type: ActionTypes.REMOVE_MATCH_CLOCK,
      payload: eventId
    };
  }

  static addBetOffer(betOffer) {
    return {
      type: ActionTypes.ADD_BET_OFFER,
      payload: betOffer
    };
  }

  /**
   * Remove bet offer action.
   * @param {number} betOfferId - Bet offer ID.
   * @return {IActionWithPayload<number>} - Action.
   */
  static removeBetOffer(betOfferId) {
    return {
      type: ActionTypes.REMOVE_BET_OFFER,
      payload: betOfferId
    };
  }

  static addBetOfferOdds(outcomes) {
    return {
      type: ActionTypes.ADD_BET_OFFER_ODDS,
      payload: outcomes
    };
  }

  static removeBetOfferOdds(outcome) {
    return {
      type: ActionTypes.REMOVE_BET_OFFER_ODDS,
      payload: outcome
    };
  }

  static updateBetOfferOdds(outcome) {
    return {
      type: ActionTypes.UPDATE_BET_OFFER_ODDS,
      payload: outcome
    };
  }

  static updateBetOfferStatus(betOfferUpdate) {
    return {
      type: ActionTypes.UPDATE_BET_OFFER_STATUS,
      payload: betOfferUpdate
    };
  }


  static setNewStartForEvent(eventId, startDate) {
    return {
      type: ActionTypes.SET_NEW_START_DATE,
      payload: {
        eventId: eventId,
        startDate: startDate
      }
    };
  }

}
